import { useEffect, useMemo } from 'react';
import type { RepositoryFile } from '@trove/core';
import { fileObjectUrl } from './fileKinds';

export function useFileObjectUrl(
  file: Pick<RepositoryFile, 'content' | 'mimeType'> | undefined,
  fallbackType = 'application/octet-stream',
) {
  const src = useMemo(() => {
    if (!file?.content) return undefined;
    return fileObjectUrl(file, fallbackType);
  }, [file?.content, file?.mimeType, fallbackType]);

  useEffect(
    () => () => {
      if (src?.startsWith('blob:')) URL.revokeObjectURL(src);
    },
    [src],
  );

  return src;
}
